import { b as B } from "./index-jyncyKHm.js";
import { a as I } from "./_commonjsHelpers-CT_km90n.js";
var N = {}, e = { exports: {} }, t = e.exports = {}, o, s;
function d() {
  throw new Error("setTimeout has not been defined");
}
function m() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? o = setTimeout : o = d;
  } catch {
    o = d;
  }
  try {
    typeof clearTimeout == "function" ? s = clearTimeout : s = m;
  } catch {
    s = m;
  }
})();
function x(r) {
  if (o === setTimeout)
    return setTimeout(r, 0);
  if ((o === d || !o) && setTimeout)
    return o = setTimeout, setTimeout(r, 0);
  try {
    return o(r, 0);
  } catch {
    try {
      return o.call(null, r, 0);
    } catch {
      return o.call(this, r, 0);
    }
  }
}
function Q(r) {
  if (s === clearTimeout)
    return clearTimeout(r);
  if ((s === m || !s) && clearTimeout)
    return s = clearTimeout, clearTimeout(r);
  try {
    return s(r);
  } catch {
    try {
      return s.call(null, r);
    } catch {
      return s.call(this, r);
    }
  }
}
var i = [], p = !1, c, f = -1;
function W() {
  !p || !c || (p = !1, c.length ? i = c.concat(i) : f = -1, i.length && h());
}
function h() {
  if (!p) {
    var r = x(W);
    p = !0;
    for (var n = i.length; n; ) {
      for (c = i, i = []; ++f < n; )
        c && c[f].run();
      f = -1, n = i.length;
    }
    c = null, p = !1, Q(r);
  }
}
t.nextTick = function(r) {
  var n = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var u = 1; u < arguments.length; u++)
      n[u - 1] = arguments[u];
  i.push(new g(r, n)), i.length === 1 && !p && x(h);
};
function g(r, n) {
  this.fun = r, this.array = n;
}
g.prototype.run = function() {
  this.fun.apply(null, this.array);
};
t.title = "browser";
t.browser = !0;
t.env = {};
t.argv = [];
t.version = "";
t.versions = {};
function a() {
}
t.on = a;
t.addListener = a;
t.once = a;
t.off = a;
t.removeListener = a;
t.removeAllListeners = a;
t.emit = a;
t.prependListener = a;
t.prependOnceListener = a;
t.listeners = function(r) {
  return [];
};
t.binding = function(r) {
  throw new Error("process.binding is not supported");
};
t.cwd = function() {
  return "/";
};
t.chdir = function(r) {
  throw new Error("process.chdir is not supported");
};
t.umask = function() {
  return 0;
};
function l() {
}
var T = (
  /** @type {boolean} */
  e.exports.browser
), b = l, w = (
  /** @type {Function} */
  e.exports.binding
), L = l, y = 1, O = {}, k = l, A = l, P = l, S = l, _ = l, j = "browser", C = "browser", $ = "browser", E = (
  /** @type {string[]} */
  []
), z = {
  nextTick: e.exports.nextTick,
  title: e.exports.title,
  browser: T,
  env: e.exports.env,
  argv: e.exports.argv,
  version: e.exports.version,
  versions: e.exports.versions,
  on: e.exports.on,
  addListener: e.exports.addListener,
  once: e.exports.once,
  off: e.exports.off,
  removeListener: e.exports.removeListener,
  removeAllListeners: e.exports.removeAllListeners,
  emit: e.exports.emit,
  emitWarning: b,
  prependListener: e.exports.prependListener,
  prependOnceListener: e.exports.prependOnceListener,
  listeners: e.exports.listeners,
  binding: w,
  cwd: e.exports.cwd,
  chdir: e.exports.chdir,
  umask: e.exports.umask,
  exit: L,
  pid: y,
  features: O,
  kill: k,
  dlopen: A,
  uptime: P,
  memoryUsage: S,
  uvCounters: _,
  platform: j,
  arch: C,
  execPath: $,
  execArgv: E
}, D = e.exports.addListener, F = e.exports.argv, G = e.exports.chdir, H = e.exports.cwd, J = e.exports.emit, K = e.exports.env, R = e.exports.listeners, V = e.exports.nextTick, X = e.exports.off, Y = e.exports.on, Z = e.exports.once, ee = e.exports.prependListener, re = e.exports.prependOnceListener, te = e.exports.removeAllListeners, ne = e.exports.removeListener, oe = e.exports.title, se = e.exports.umask, ie = e.exports.version, ae = e.exports.versions;
const ue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addListener: D,
  arch: C,
  argv: F,
  binding: w,
  browser: T,
  chdir: G,
  cwd: H,
  default: z,
  dlopen: A,
  emit: J,
  emitWarning: b,
  env: K,
  execArgv: E,
  execPath: $,
  exit: L,
  features: O,
  kill: k,
  listeners: R,
  memoryUsage: S,
  nextTick: V,
  off: X,
  on: Y,
  once: Z,
  pid: y,
  platform: j,
  prependListener: ee,
  prependOnceListener: re,
  removeAllListeners: te,
  removeListener: ne,
  title: oe,
  umask: se,
  uptime: P,
  uvCounters: _,
  version: ie,
  versions: ae
}, Symbol.toStringTag, { value: "Module" })), ce = /* @__PURE__ */ I(ue);
(function(r) {
  Object.defineProperty(r, Symbol.toStringTag, { value: "Module" });
  const n = B, u = ce, q = (v) => v && v.__esModule ? v : { default: v }, M = q(u), U = globalThis || void 0 || self;
  Object.defineProperty(r, "Buffer", { enumerable: !0, get: () => n.Buffer }), Object.defineProperty(r, "process", { enumerable: !0, get: () => M.default }), r.global = U;
})(N);
export {
  N as d
};
//# sourceMappingURL=index-Buti0PLx.js.map
